module.exports = {"410821100":"城关镇","410821101":"七贤镇","410821102":"郇封镇","410821103":"周庄镇","410821104":"云台山镇","410821202":"王屯乡","410821204":"五里源乡","410821206":"西村乡","410821400":"小营工贸区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410821.json
// module id = 1466
// module chunks = 0